import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import axios from 'axios';
import CustomPaginator from './CustomPaginator';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const RelatedProducts = ({ config }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);

  useEffect(() => {
    fetchProductData();
  }, [first, rows, sortField, sortOrder]);

  const fetchProductData = async () => {
    try {
      setLoading(true);
      const offset = first;
      const limit = rows;
      const sort_by = sortField ? sortField : 'sort_order';
      const sort_order = sortOrder === 1 ? 'asc' : 'desc';
      const response = await axios.get(`${config.PY_API_URL}related/products`, {
        params: {
          offset,
          limit,
          sort_by,
          sort_order,
          return_periods: '3,5',
          product_code: config.product_code
        }
      });

      const { data } = response;
      if (data && data.data && data.data.products) {
        setProducts(data.data.products);
        setTotalRecords(data.data.total_count);
      } else {
        setProducts([]);
        setTotalRecords(0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching product data:', error);
      setLoading(false);
    }
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const onSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  return (
    <div>
      {products && products.length > 0 ? (
        <DataTable
          value={products}
          paginator={false}
          rows={rows}
          totalRecords={totalRecords}
          loading={loading}
          onSort={onSort}
          sortField={sortField}
          sortOrder={sortOrder}
          responsiveLayout="scroll"
          tableStyle={{ minWidth: '60rem' }}
        >
          <Column
            body={rowData => (
              <img 
                style={{ maxWidth: '40px' }} 
                src={rowData.icon} 
                alt="Icon" 
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null;
                  currentTarget.src="https://via.placeholder.com/40x40";
                }}
              />
            )}
            responsivePriority={1}
          />
          <Column field="unique_code" header="Scheme Code" sortable responsivePriority={2} />
          <Column field="name" header="Scheme Name" sortable />
          <Column
            field="nav"
            header="Net Asset Value"
            // sortable
            body={rowData => rowData['nav'] || 'N/A'}
          />
          <Column
            field="returns_3_years"
            header="3Y Return"
            // sortable
            body={rowData => rowData['returns_3_years'] || 'N/A'}
          />
          <Column
            field="returns_5_years"
            header="5Y Return"
            // sortable
            body={rowData => rowData['returns_5_years'] || 'N/A'}
          />
          <Column
            body={rowData => (
              // <a href={`${config.siteUrl}/product/?product_code=${rowData['product_code']}`}>Details</a>
              <a href={`${config.siteUrl}/product-detail/${rowData['product_code']}`}>Details</a>
            )}
            responsivePriority={1}
          />
        </DataTable>
      ) : (
        <p></p>
      )}
      
      {totalRecords > rows && (
        <CustomPaginator
          first={first}
          rows={rows}
          totalRecords={totalRecords}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};

export default RelatedProducts;
